import {gatewayInstance} from "../axiosInstance";
import {SERVICE_ENDPOINT} from "../const";

export const optionTypeDropdown = async () => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/option-config-type`,
        );

        return response.data.map((item) => ({
            key: item.optId,
            text: item.optName,
            value: item.optValue,
            code: item.optCode,
        }));
    } catch (e) {
        console.error(e);
    }
};

export const searchOptions = async (data) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/option-config/search`,
            data,
        );
        return response.data;
    } catch (e) {
        console.error();
    }
};

export const getOptionsByType = async (type, params = {}) => {
    const res = await gatewayInstance.get(
        `${SERVICE_ENDPOINT.TRANSPORT}/option-config/search/type/${encodeURIComponent(type)}`,
        { params }
    );
    return res.data;
};


export const addOptionData = async (data) => {
    const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/option-config/save`,
        data,
    );
    return response.data;
};

export const updateOptionData = async (data) => {
    const { keyId, ...rest } = data;
    const res = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/option-config/update`,
        rest,
        { params: { keyId } }
    );
    return res.data;
};
